var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{ref:"router"},[_c('router-view',{class:[{'router-view':!_vm.isMobile},{'router-view-mobile':_vm.isMobile}]})],1),(_vm.footerVisible)?_c('Footer',{ref:"footer"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }